import React, { useEffect, useRef } from "react";
import HeartLoader from "@/components/HeartLoader";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { nav("/auth"); return; }
      let referral = null;
      try { referral = localStorage.getItem("rud_ref") || null; } catch (e) { /* noop */ }
      try {
        const { data } = await api.post("/auth/session", { referral_code: referral }, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        try { localStorage.removeItem("rud_ref"); } catch (e) { /* noop */ }
        window.history.replaceState(null, "", window.location.pathname);
        nav("/");
      } catch (e) {
        if (e?.response?.status === 403 && e?.response?.data?.detail === "invite_only") {
          window.history.replaceState(null, "", window.location.pathname);
          nav("/auth?denied=invite");
        } else {
          nav("/auth");
        }
      }
    };
    run();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="flex items-center gap-3 text-sec"><HeartLoader /> Completing sign-in…</div>
    </div>
  );
}
